export default __webpack_public_path__ + "static/media/Shield Done.b4e8a8d3.svg";